import { EventEmitter } from '@angular/core';
import { ActionType } from '@core-lib/enums';
import { IAction, IDatagridSettings, IDatagridSort } from '@core-lib/models';

export class DatagridActionHandler<SortableCols> {
	action: EventEmitter<IAction> = new EventEmitter();

	private settingsDispatcher: any;

	withSettingsDispatcher(settingsDispatcher: any): this {
		this.settingsDispatcher = settingsDispatcher;
		return this;
	}

	setSort(sort: IDatagridSort<SortableCols>): void {
		this.action.emit({ type: ActionType.Sort, value: sort });
		this.dispatchSettings({ sort });
	}

	setPageNumber(pageNumber: number): void {
		this.action.emit({ type: ActionType.SetPageNumber, value: pageNumber });
		this.dispatchSettings({ pageNumber });
	}

	setPageSize(pageSize: number): void {
		this.action.emit({ type: ActionType.SetPageSize, value: pageSize });
		this.dispatchSettings({ pageSize });
	}

	dispatchSettings(settings: Partial<IDatagridSettings<SortableCols>>): void {
		if (this.settingsDispatcher) {
			this.settingsDispatcher(settings);
		}
	}
}
